import * as React from 'react';
import { Button, Image, UIHeading3, UIText2 } from '@cian/ui-kit';
import { IconCommunicationMessage16 } from '@cian/ui-kit-design-tokens/icons';
import * as styles from './ContactListItem.css';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
export var ContactListItem = function ContactListItem(_ref) {
  var logoUrl = _ref.logoUrl,
    subtitle = _ref.subtitle,
    title = _ref.title,
    buttonTheme = _ref.buttonTheme,
    onClick = _ref.onClick;
  return /*#__PURE__*/_jsxs("li", {
    className: styles['contact'],
    children: [/*#__PURE__*/_jsx("div", {
      className: styles['logo'],
      children: /*#__PURE__*/_jsx(Image, {
        borderRadius: 0,
        objectFit: "contain",
        src: logoUrl !== null && logoUrl !== void 0 ? logoUrl : ''
      })
    }), /*#__PURE__*/_jsxs("div", {
      className: styles['text'],
      children: [/*#__PURE__*/_jsx(UIText2, {
        color: "text-secondary-default",
        children: subtitle
      }), title && /*#__PURE__*/_jsx(UIHeading3, {
        children: title
      })]
    }), /*#__PURE__*/_jsx("div", {
      className: styles['button'],
      children: /*#__PURE__*/_jsx(Button, {
        fullWidth: true,
        theme: buttonTheme,
        beforeIcon: /*#__PURE__*/_jsx(IconCommunicationMessage16, {
          color: "current_color"
        }),
        onClick: onClick,
        children: "\u041D\u0430\u043F\u0438\u0441\u0430\u0442\u044C"
      })
    })]
  });
};